import { cn } from "@/lib/utils";

interface TocItem {
	title: string;
	slug: string;
	items?: TocItem[];
}

function TocList({ items, level = 0 }: { items: TocItem[]; level?: number }) {
	if (items.length === 0) return null;
	return (
		<ul
			className={cn(
				"grid gap-2",
				level > 0 && "mt-2 border-l border-border/60 pl-3",
			)}
		>
			{items.map((item) => (
				<li key={item.slug}>
					<a
						href={`#${item.slug}`}
						className="block text-sm text-muted-foreground transition-colors hover:text-foreground"
					>
						{item.title}
					</a>
					{item.items && item.items.length > 0 ? (
						<TocList items={item.items} level={level + 1} />
					) : null}
				</li>
			))}
		</ul>
	);
}

export default function TableOfContents({
	items,
	className,
	showHeading = true,
}: {
	items: TocItem[];
	className?: string;
	/** When false, only the link list is rendered (e.g. inside a collapsible trigger panel). */
	showHeading?: boolean;
}) {
	if (!items?.length) return null;

	return (
		<nav
			aria-label="On this page"
			className={cn(
				"flex flex-col",
				showHeading ? "gap-3" : "gap-0",
				className,
			)}
		>
			{showHeading ? (
				<h2 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
					On this page
				</h2>
			) : null}
			<TocList items={items} />
		</nav>
	);
}
